import { createContext, useContext } from 'react';
import { Snapshot } from '../types/core.type';

type SnapshotState = {
  snapshot: Snapshot;
  setSnapshot: (snapshot: Snapshot) => void;
};
export const SnapshotContext = createContext<SnapshotState | undefined>(undefined);

export default function useSnapshot() {
  const context = useContext(SnapshotContext);

  if (context === undefined) {
    throw new Error('useSnapshot must be used within a SnapshotProvider');
  }

  return context;
}
